import request from "@/utils/request";

//1,添加用户
export function addAdminUser(data){
    return request({
        url:'/admin/addAdminUser',
        data:data,
        method:'post'
    })
}
//2,修改密码
export function changeAdminPassword(data){
    return request({
        url:'/admin/changeAdminPassword',
        data:data,
        method:'post'
    })
}
//3,列表
export function getAdminUsers(data){
    return request({
        url:'/admin/getAdminUsers',
        data:data,
        method:'get'
    })
}
//4,修改信息
export function updateAdminUser(data){
    return request({
        url:'/admin/updateAdminUser',
        data:data,
        method:'post'
    })
}
//4,状态
export function changeAdminStatus(data){
    return request({
        url:'/admin/changeAdminStatus',
        data:data,
        method:'post'
    })
}

//4,删除
export function removeAdminUser(data){
    return request({
        url:'/admin/removeAdminUser',
        data:data,
        method:'post'
    })
}
